import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { LoginService } from 'src/app/api/authentication';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {

  forgotPasswordForm: FormGroup
  forgotTokenForm: FormGroup
  forgot: boolean = false

  sendToken: boolean = false

  qttForRequisition: number = 1

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private loginService: LoginService,
    private router: Router,
    private spinner: NgxSpinnerService
  ) {
    this.forgotTokenForm = this.fb.group({
      userName: ['', [Validators.required, Validators.email]],
      token: ['', Validators.required],
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required],
    })
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  submitForgot() {
    if (this.forgotPasswordForm.valid) {
      this.spinner.show()
      this.loginService.forgotPassword(this.forgotPasswordForm.value).subscribe(response => {
        this.spinner.hide()
        this.sendToken = true
        this.forgotTokenForm.get('userName')?.patchValue(this.forgotPasswordForm.get('userName')?.value)
        this.toastr.success('Senha enviada para seu e-mail', 'Sucesso!')
      }, error => {
        this.spinner.hide()
        this.toastr.error(`E-mail não encontrado`)
        this.forgotPasswordForm.reset()
      })
    } else {
      this.toastr.error('Preencha os campos inválidos')
    }
  }

  submitToken() {
    if (this.forgotTokenForm.valid && this.equalsForm) {
      this.spinner.show()
      this.loginService.forgotPasswordToken(this.forgotTokenForm.value).subscribe(response => {
        this.spinner.hide()
        this.toastr.success('Senha Alterada !', 'Sucesso!')
        setTimeout(() => {
          this.router.navigate(['/login'])
        }, 3000);
      }, error => {
        this.spinner.hide()
        if (this.qttForRequisition == 4) {
          this.sendToken = false
          this.toastr.error('Quantidade de tentativas excedida!', 'Tente novamente !')
          this.router.navigate(['/login'])
        }
        this.qttForRequisition++
        this.toastr.error('Verifique se o Token ou se as senhas estão corretas', 'Error!')
        this.forgotTokenForm.get('token')?.reset()
        this.forgotTokenForm.get('password')?.reset()
        this.forgotTokenForm.get('confirmPassword')?.reset()
      })
    } else {
      this.toastr.error('Preencha os campos inválidos')
    }
  }

  get emailForgot() {
    return this.forgotPasswordForm.get('email')
  }

  get equalsForm() {
    return this.forgotTokenForm.get('password')?.value == this.forgotTokenForm.get('confirmPassword')?.value
  }
}
